<template>
    <div class="shangwushuju-layer">
        <caseheader></caseheader>
        
        <div class="sh-container">
            <!-- <iframe src="http://192.168.20.198:7890/#/loginAuto?account=dy019&pwd=888888&trainingType=24" frameborder="0" width="100%" height="100%"></iframe> -->
             <iframe :src="SWSJURL" frameborder="0" width="100%" height="100%"></iframe>
        </div>
    </div>
</template>

<script>
import Caseheader from '@/components/layout/caseheader.vue';

export default {
    name: '',
    components: {
        Caseheader
    },
    props: {},
    data() {
        return {
            SWSJweb: SWSJweb
        }
    },
    computed: {
        SWSJURL () {
            let account = sessionStorage.getItem('dygptaccount')
            let pwd = sessionStorage.getItem('dygptpwd')
            let relatedId = sessionStorage.getItem('relatedId')
            let url = SWSJweb + '?account=' + account + '&pwd=' + pwd + '&trainingType=' + relatedId
            return url
        }
    },
    watch: {},
    created() { },
    mounted() { },
    methods: {
       
    }
}
</script>

<style scoped lang="less">
.shangwushuju-layer {
    height: 100%;

    .sh-container {
        padding: 20px;
        display: flex;
        gap: 20px;
        height: calc(100% - 100px);
        width: calc(100% - 40px);

        .sh-content {
            flex: 1;
            background: rgba(5, 5, 5, 0.68);
            border-radius: 25px;
            color: #fff;
            padding: 30px;
            height: calc(100% - 60px);
        }
    }
}
</style>
